// extracted by mini-css-extract-plugin
module.exports = {"header":"items_list_header__27DYP","item":"items_list_item__zDZUP"};